export enum DistrictGameAccess {
  Blocked = 'B',
  OptIn = 'P',
  Open = 'O'
}
